import { Component, Input, OnInit } from '@angular/core';
import { GlobalsService } from 'src/app/api/globals.service';
import { AuthService } from 'src/app/services/auth.service';
import { CursosService } from 'src/app/services/cursos.service';

@Component({
  selector: 'app-view-actividades',
  templateUrl: './view-actividades.component.html',
  styleUrls: ['./view-actividades.component.scss'],
})
export class ViewActividadesComponent implements OnInit {

  @Input() public curso: any;
  @Input() public ID_LIBROCURSO: any;
  @Input() public ID_TIPO: number;
  @Input() public NOMBER_ACTIVIDAD: string;
  @Input() public student: any;
  @Input() public setStep: (step: number) => void;
  private ID_ACTIVIDAD = 0;

  displayUserData: any;
  nombre_actividad: string;
  ejercicio_numero: number;
  explicacion_titulo: any;


  current_act: number = 0;
  total_act: number = 0;

  act_h: number = 0;
  act_m: number = 0;
  act_s: number = 0;
  act_sec = 0;
  act_min = 0;
  act_hrs = 0;
  time_ejercicio = '';
  id_ejercico = '';
  id_tipo_ejercicio = '';
  id_ejercicoTemp = '';
  id_tipo_ejercicioTemp = '';
  idInterval: any;
  hAux: any;
  mAux: any;
  sAux: any;

  stepsActive: number = 0;
  ismobile: boolean;

  actividades: any = [];
  actividad: number;
  componentView: any = [];
  respuestasEjercicios: any = [];

  setIntervalPaused=false;
  stepFinish = 0;

  _SAVE_DATA: any = [];
  fecha_ini: any;

  private id: number;
  public is_curso: boolean = false;
  private auth_key: string;
  public activityCourse: any = [];
  public exerciseCourse: any = [];
  public respuestasActividad: any = {};
  listaAcividadesCurso=[];
  stepAux = 0;
  inicio_actividad_key = "";

  finishActivity = false;
  finishOption = 0;
  selectedStars = 1;

  constructor(
    private cursosService: CursosService,
    private authService:AuthService,
    public globalsService: GlobalsService,
  ) {
    this.ismobile = globalsService.isMobile;
    this.componentView = [
      {
        tipo: 1,
        active: -1,
        data: null
      },
      {
        tipo: 2,
        active: -1,
        data: null
      },
      {
        tipo: 3,
        active: -1,
        data: null
      },
      {
        tipo: 4,
        active: -1,
        data: null
      },
      {
        tipo: 5,
        active: -1,
        data: null
      },
      {
        tipo: 6,
        active: -1,
        data: null
      },
      {
        tipo: 7,
        active: -1,
        data: null
      },
      {
        tipo: 8,
        active: -1,
        data: null
      }
    ];
  }

  ngOnInit() {
    console.log("file: view-actividades.component.ts:11 >> curso:", this.curso)
    console.log("file: view-actividades.component.ts:12 >> ID_LIBROCURSO:", this.ID_LIBROCURSO)
    console.log("file: view-actividades.component.ts:13 >> ID_TIPO:", this.ID_TIPO)
    console.log("file: view-actividades.component.ts:15 >> NOMBER_ACTIVIDAD:", this.NOMBER_ACTIVIDAD)
    console.log("file: view-actividades.component.ts:15 >> student:", this.student)
    this.loadUserData();

  }

  async loadUserData() {
    await this.authService.userData$.subscribe((res: any) => {
      console.log("loadUserData res: ", res);
      if (res) {
        if (!this.displayUserData) {
          this.displayUserData = res;
          this.id = this.displayUserData?.id;
          this.auth_key = this.displayUserData?.auth_key;
        }
      }
    });

    console.log("file: view-actividades.component.ts:106 >> this.student.id_user, this.curso.id, this.auth_key, this.ID_LIBROCURSO.id, this.ID_LIBROCURSO.tipo:", this.student.id_user, this.curso.id, this.auth_key, this.ID_LIBROCURSO.id, this.ID_LIBROCURSO.tipo)
    await this.cursosService.verActividadEstudianteCurso(this.student.id_user, this.curso.id, this.auth_key, this.ID_LIBROCURSO.id, this.ID_LIBROCURSO.tipo, 0).subscribe(response => {

      let res: any;
      console.log("file: view-actividades.component.ts:109 >> response:", response)
      // if (response) {
      //   res = response;
      //   res.forEach(element => {
      //     if (element) {
      //       this.listaAcividadesCurso.push(element.activities);
      //     }
      //   });
      //   // if (res[0])
      //   //   this.listaAcividadesCurso = res[0].activities;
      //   console.log('EstudianteCursoPage - cursosService - listaAcividadesCurso: ', this.listaAcividadesCurso);
      //   let actividades: any = response;

      //   this.listaAcividadesCurso[0].forEach((element, i) => {
      //     // this.actividades.push(element);
      //     console.log("file: view-actividades.component.ts:172 >> element:", element)
      //     this.componentView.forEach((cv, j) => {
      //       if (cv.tipo == element.data.id_tipo) {
      //         this.componentView[j].active = (i);
      //         let extra = null;
      //         if (element.dataOp != undefined) {
      //           extra = element.dataOp;
      //         }
      //         this.componentView[j].data = { data: element.data, extra: extra };
      //         // console.log("Storage Component:",this.componentView[j].data.data);
      //         this.ID_ACTIVIDAD = this.componentView[j].data.data.id_actividad;
      //       }
      //     });
      //     console.log("file: view-actividades.component.ts:182 >> this.componentView:", this.componentView)
      //   });
      // }
    });

  }

}
